import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';
import { useAuthStore } from '~/store/auth.store';

import { getCatalogStats, getCurationStats } from '../services/catalog-operations.service';

/** Fetches and caches listing-page aggregates (4 stat cards + alert banner).
 *  Disabled until the user's active tenant resolves so the call doesn't fire
 *  with missing auth context during cold loads or login redirects. */
export function useCatalogStats() {
  const subsidiaryId = useAuthStore((s) => s.user?.activeTenantId);
  return useQuery({
    queryKey: queryKeys.catalogOperations.stats(),
    queryFn: getCatalogStats,
    enabled: Boolean(subsidiaryId),
  });
}

/** Fetches subsidiary-scoped curation aggregates (drives alert-banner
 *  visibility + count). The endpoint reads the active subsidiary from the
 *  `x-subsidiary-id` header (auto-injected); the store value is only used
 *  here to scope the cache key and disable the call until login resolves. */
export function useCurationStats() {
  const subsidiaryId = useAuthStore((s) => s.user?.activeTenantId);
  return useQuery({
    queryKey: queryKeys.curation.stats(subsidiaryId ?? ''),
    queryFn: getCurationStats,
    enabled: Boolean(subsidiaryId),
  });
}
